import React, {useContext, useRef} from 'react';
import propTypes from 'prop-types';
import { useGSAP } from '@gsap/react';
import Context from '../OriginStoryProvider';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap';

const HeadlineQuote = ({ elClass, quote, source }) => {
	const { data: {content} } = useContext(Context);
	
	const headlineQuoteContainer = useRef(null);
	const headlineQuoteText = useRef(null);

	useGSAP(() => {
		const split = new SplitText(headlineQuoteText.current, { type: 'chars, words', wordsClass: 'word' });

		const tl = gsap.timeline()
			.to(`.${elClass}__quote`, {
				'--lquo-opacity': 1,
			})
			.from(split.chars, {
				opacity: 0,
				rotate: (i) => -i * 0.1,
				y: (i) => -i * 0.1,
				skewY: -5,
				stagger: 0.2,
			})
			.from(`.${elClass}__citation`, {
				opacity: 0,
			})

		ScrollTrigger.create({
			trigger: headlineQuoteContainer.current,
			start: 'center center',
			end: 'bottom+=150%',
			pin: headlineQuoteContainer.current,
			scrub: 2,
			animation: tl,
		});

	}, {scope: headlineQuoteContainer.current, dependencies: [content.chapters]});

	return (
		<div className={`${elClass}__wrapper`}>
			<div className={`${elClass}__container main-grid`} ref={headlineQuoteContainer}> 
				<div className='main-grid__margin'></div>
				<div className='main-grid__body'>
					<p className={`${elClass}__quote headline-quote`} ref={headlineQuoteText}>{quote}&rdquo;</p>
					<cite className={`${elClass}__citation quote-attribute`} dangerouslySetInnerHTML={{__html: source}}></cite>
				</div>
				<div className='main-grid__margin'></div>
			</div>
		</div>
	)
}

export default HeadlineQuote;

HeadlineQuote.propTypes = {
	quote: propTypes.string.isRequired,
	source: propTypes.string.isRequired,
	elClass: propTypes.string.isRequired
}
